<template>
   <div v-if="isModalShown">
        <div class="modal-mask" role="dialog" style="z-index: 99999">
            <div class="modal-dialog">
                <div class="modal-content loading-div">
                    <div class="modal-body center">
                        <br><br><br><br><br><br><br>
                        <img src="../../../static/img/loading.gif">
                    </div>
                </div>
            </div>
        </div>
   </div>
</template>
<script>
export default {
    data() {
        return {
            isModalShown: true,
        }
    },
    methods: {
    }
}
</script>



// WEBPACK FOOTER //
// LoadingComponent.vue?2199275f